import { useState } from 'react';
import { useT } from '@hana/i18n';
import './screens.i18n';
import { IconLayoutList, IconPlus, IconRefresh, IconSitemap } from '@tabler/icons-react';
import { Button, Segmented, useToast } from '@hana/ui';
import { HrOrgJd } from './HrOrgJd';
import { HrOrgList } from './HrOrgList';
import { HrOrgTree } from './HrOrgTree';
import { ORG_VIEWS } from './overview';
import type { OrgBlock } from './types';
import s from './hr.module.css';

// Mint-HR · tab Cơ cấu & ghế (design-specs/Mint-HR-OrgTree.md). Sơ đồ ghế (Cây tổ chức) · Phòng ban · Chức danh · Bậc · JD; chế độ Danh sách của Sơ đồ ghế chưa mở.

export function HrOrg({ blocks }: { blocks: readonly OrgBlock[] }) {
  const t = useT();
  const toast = useToast();
  const [view, setView] = useState<'map' | 'dept' | 'title' | 'level' | 'jd'>('map');
  const [mode, setMode] = useState<'list' | 'tree'>('tree');
  const soon = () => toast({ msg: 'Phần này chưa mở ở bản này' });
  return (
    <>
      <div className={s.orgBar}>
        <Segmented
          kind="toggle"
          label="Phần cơ cấu"
          value={view}
          onChange={(k) => setView(k as typeof view)}
          items={ORG_VIEWS.map((v) => ({ key: v.key, label: v.label, n: 'n' in v ? v.n : undefined }))}
        />
        {view === 'map' && (
          <Segmented
            kind="toggle"
            label="Chế độ xem ghế"
            value={mode}
            onChange={(k) => { if (k === 'tree') setMode(k); else soon(); }}
            items={[
              { key: 'list', label: <><IconLayoutList size={16} aria-hidden="true" />{t('hr.s.list')}</> },
              { key: 'tree', label: <><IconSitemap size={16} aria-hidden="true" />{t('hr.s.orgTree')}</> },
            ]}
          />
        )}
        {view === 'jd' && <span className={s.mute}>{t('hr.s.jdDesc')}</span>}
        <span className={s.grow} />
        <Button icon={<IconRefresh size={16} aria-hidden="true" />} onClick={() => toast({ msg: t('hr.s.noWrite') })}>{t('hr.s.syncSeats')}</Button>
        {(view === 'dept' || view === 'title') && (
          <Button className={s.olAdd} icon={<IconPlus size={16} aria-hidden="true" />} onClick={() => toast({ msg: t('hr.s.noWrite') })}>{view === 'dept' ? 'Phòng / tổ' : 'Chức danh'}</Button>
        )}
      </div>
      {view === 'map' && <HrOrgTree blocks={blocks} />}
      {(view === 'dept' || view === 'title' || view === 'level') && <HrOrgList view={view} blocks={blocks} />}
      {view === 'jd' && <HrOrgJd />}
    </>
  );
}
